import React from 'react';
import escape from 'lodash/escape';
import { StyledSpan } from './styled';

export const RawHTML = ({ html, escaped = true, ...rest }) => {
    return <StyledSpan {...rest} dangerouslySetInnerHTML={{ __html: escaped ? escape(html) : html }} />;
};
